<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>پروفایل</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="user.name" label="نام"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field color="black" v-model="user.email" label="ایمیل"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field color="black" v-model="user.password" label="رمز عبور"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field color="black" v-model="user.mobile" label="موبایل"></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn color="primary" @click="update" style="letter-spacing: normal!important;">
              ثبت
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="my-6"></v-divider>
        <v-row>
          <v-col cols="12">
            <v-card-title class="pa-0">فعالیت‌های اخیر</v-card-title>
          </v-col>
          <v-col cols="12">
            <v-alert type="info" dense text v-if="!user.recent_activities || !user.recent_activities.length">
              هنوز فعالیتی ثبت نشده است.
            </v-alert>
            <v-data-table
                v-else
                :headers="activityHeaders"
                :items="user.recent_activities"
                dense
                hide-default-footer
            >
              <template v-slot:[`item.title_fa`]="{ item }">
                {{ item.title_fa }}
              </template>
              <template v-slot:[`item.created_at_fa`]="{ item }">
                {{ item.created_at_fa }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ProfileEdit",
  data() {
    return {
      userType: null,
      user: {
        name: null,
        email: null,
        password: null,
        mobile: null,
        recent_activities: []
      },
      activityHeaders: [
        { text: 'زمان', value: 'created_at_fa' },
        { text: 'کاربر', value: 'user_name' },
        { text: 'آخرین فعالیت', value: 'title_fa' },
        { text: 'صفحه', value: 'route_path' },
      ],
      loading: true
    }
  },
  mounted() {
    if (this.$cookies.get('userType') === 'admin') {
      this.userType = "admins"
    } else {
      this.userType = "instructors"
    }
    this.getProfile()
  },
  methods: {
    getProfile() {
      let url = ''
      if (this.userType === 'admins') {
        url = 'admin/auth/profile'
      } else {
        url = 'instructor/auth/profile'
      }
      window.axios.get(url).then((res) => {
        this.user = res.data.data
        this.loading = false
      })
    },
    update() {
      let url = ''
      url = this.userType === 'admins'
          ? 'admin/admin/update/'+this.$store.state.user.id
          : 'instructor/auth/update/'+this.$store.state.user.id
      window.axios.post(url, {
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        mobile: this.user.mobile,
      }).then(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>

</style>
